export const LEGACY_SITE_ORIGIN = "https://openfusionlab.com";
export const PRIMARY_SITE_ORIGIN = "https://equilibrium.openfusionlab.com";

export interface LocationLike {
  origin: string;
  pathname: string;
  search: string;
  hash: string;
}

/** Return the exact primary-site URL for the legacy production origin only. */
export function legacyRedirectTarget(location: LocationLike): string | null {
  if (location.origin !== LEGACY_SITE_ORIGIN) return null;
  if (!location.pathname.startsWith("/")) return null;
  return `${PRIMARY_SITE_ORIGIN}${location.pathname}${location.search}${location.hash}`;
}

export function redirectLegacyOrigin(location: LocationLike, replace: (target: string) => void): boolean {
  const target = legacyRedirectTarget(location);
  if (target === null) return false;
  replace(target);
  return true;
}
